import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import DirectPage from './pages/DirectPage';
import SubmitPage from './pages/SubmitPage';
import TasksPage from './pages/TasksPage';
import TaskDetailPage from './pages/TaskDetailPage';
import ProfilePage from './pages/ProfilePage';
import KnowledgeVizPage from './pages/KnowledgeVizPage';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/direct" element={<DirectPage />} />
            <Route path="/submit" element={<SubmitPage />} />
            <Route path="/tasks" element={<TasksPage />} />
            <Route path="/task-detail/:id" element={<TaskDetailPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/viz" element={<KnowledgeVizPage />} />
          </Route>
          <Route path="/" element={<Navigate to="/direct" replace />} />
          <Route path="*" element={<Navigate to="/direct" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}